export default "__VITE_ASSET__BAfVoqJy__"